<template>
  <el-container>
    <!--左边-->
    <div ref="sideInitHeight" id="sideInitHeight" style="background: #545c64;">
      <!--头像-->
      <div style="margin-top:10px;height:150px;color: #fff;font-size:12px;text-align: center;display: flex;flex-direction: column;align-items: center" v-show="!isCollapse">
        <img src="../../static/img/HSLogo.png" alt="用户头像" style = "width:80px;height:80px;display:block;margin:0
           auto;" />
        <div style="flex: 1;display: flex;flex-direction: column;align-items: center;justify-content: space-around">
          <div style="flex: 1;display: flex;justify-content: center;align-items: center">欢迎您!</div>
          <!--<div style="flex: 1;display: flex;justify-content: center;align-items: center">{{roleName}}</div>-->
          <div style="flex: 1;display: flex;justify-content: center;align-items: center">{{date}}</div>
        </div>
      </div>

      <!--左侧菜单-->
      <div class="el-menu-vertical-demo-grandparents" :style="isCollapse?{'height':`${clientHeight}px`}:{'height':`${clientHeight-160}px`}">
        <div class="el-menu-vertical-demo-parent" :style="isCollapse?{'paddingRight':'0'}:{'paddingRight':'17px'}">
          <el-menu :collapse="isCollapse"
                   mode="vertical"
                   :default-active="activePath"
                   background-color="#545c64"
                   text-color="#fff"
                   :router="routerFlag"
                   id="menu"
                   class="el-menu-vertical-demo"
                   active-text-color="#ffd04b"
          >
            <div v-for="(m,index) in modularArr" :key="index" style="background: #545c64;" class="el-menu-vertical-demo-child">
              <div class="el-menu-vertical-demo-childSend">
                <el-submenu :index="(index+1)+''">
                  <!--一级菜单-->
                  <template slot="title">
                    <i :class="`iconfont ${m.menuIcon.substring(1)} iconMenuOne f1`"></i>
                    <!--<svg class="iconMenuOne fl">
                      <use :xlink:href="m.menuIcon"></use>
                    </svg>-->
                    <span>{{isCollapse? '':m.menuName}}</span>
                  </template>

                  <!--二级菜单-->
                  <div>
                    <el-menu-item v-for="(c,idx) in m.childMenus" :key="idx" :index="c.menuUrl">
                      <i :class="`iconfont ${c.menuIcon.substring(1)} iconMenu f1`"></i>
                      <!--<svg class="iconMenu fl">
                        <use :xlink:href="c.menuIcon"></use>
                      </svg>-->
                      {{c.menuName}}
                    </el-menu-item>
                  </div>
                </el-submenu>

              </div>
            </div>
          </el-menu>
        </div>
      </div>
    </div>

    <!--右边-->
    <el-main style="min-width: 1000px">
      <!--头部-->
      <el-header class="clearfix" ref="elHeader" >
        <svg class="icon fl" aria-hidden="true" @click="hideOrShowSide">
          <use :xlink:href="openOrClose"></use>
        </svg>
        <div class="fl welcome">欢迎您登录华晟医学官网管理系统！</div>
        <div class="fr" style="cursor: pointer;margin:0 20px 0 30px;display: flex;align-items: center">
          <svg class="iconExit fl" aria-hidden="true" @click="exitSystem">
            <use xlink:href="#icon-tuichu1">1</use>
          </svg>
          <div class="fl" style="font-size: 14px;" @click="exitSystem">退出系统</div>
        </div>
        <div class="fr" style="cursor: pointer;display: flex;align-items: center">
          <svg class="icon2 fl" aria-hidden="true" @click="modifyPassword" >
            <use xlink:href="#icon-xiugaimima1"></use>
          </svg>
          <div class="fl" style="font-size: 14px;" @click="modifyPassword">修改密码</div>
        </div>
      </el-header>
      <!--主体-->
      <div class="el-right-main"  ref="rightContainer" id="rightContainer" >
        <router-view></router-view>
      </div>
      <el-dialog title="修改登录密码" :visible.sync="dialogPassword"  width="25%">
        <el-form :model="passwordForm"  label-width="120px" :rules="rulesForm" ref="form">
          <el-form-item label="旧密码：" prop="oldPassword">
            <el-input v-model="passwordForm.oldPassword" type="password"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" prop="newPassword">
            <el-input v-model="passwordForm.newPassword" type="password"></el-input>
          </el-form-item>
          <el-form-item label="确认新密码：" prop="repeatNewPassword">
            <el-input v-model="passwordForm.repeatNewPassword" type="password"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogPassword = false">取 消</el-button>
          <el-button type="primary" @click="submitNewPassword">确 定</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      let validateOld = (rule, value, callback) =>{
        if(!/^([0-9]|[a-zA-Z]){6,16}$/.test(value)){
          return callback(new Error('请输入旧密码'));
        }else{
          callback();
        }
      }
      let validateNew = (rule, value, callback) =>{
        if(!/^(?=.*\d)(?=.*[a-z]).{6,16}$/.test(value)){
          return callback(new Error('请输入6-16位字母和数字组合'));
        }else{
          callback();
        }
      }
      let validateRepeatNew = (rule, value, callback) =>{
        if(!/^(?=.*\d)(?=.*[a-z]).{6,16}$/.test(value)){
          return callback(new Error('请重复新密码'));
        }else if(value !== this.passwordForm.newPassword){
          return callback(new Error('两次输入的密码不一致'));
        }else{
          callback();
        }
      }
      return {
        routerFlag:true,
        modularArr:[],
        openOrClose:'#icon-caidan',
        passwordForm:{oldPassword:'',newPassword:'',repeatNewPassword:''},
        dialogPassword:false,
        isCollapse:false,
        activePath:'',
        roleName:'',
        userName:'',
        menuHeight: 0, // 左侧菜单的高
        clientHeight:'',
        rulesForm:{
          oldPassword:[{validator: validateOld, trigger: 'blur', required: true}],
          newPassword:[{validator: validateNew, trigger: 'blur', required: true}],
          repeatNewPassword:[{validator: validateRepeatNew, trigger: 'blur', required: true}]
        }
      }
    },
    created(){
      this.init();
      this.queryModular();
    },
    mounted(){
      //this.demo();
      window.onresize = function(){
        let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        if (document.getElementById("sideInitHeight")) document.getElementById("sideInitHeight").style.height = h + 'px';
        if (document.getElementById("rightContainer")) document.getElementById("rightContainer").style.height = (h - 80) + "px"
      };
      let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      this.$refs.sideInitHeight.style.height = h + 'px';
      this.$refs.rightContainer.style.height = (h - 80) + "px"
    },
    methods: {
      demo(){
        document.getElementById('app').addEventListener('mousedown',function () {
          event.stopPropagation();
        })
        document.getElementsByClassName('el-container')[0].addEventListener('mousedown',function () {
          event.stopPropagation();
        })
        document.getElementById('app').addEventListener('mouseup',function () {
          event.stopPropagation();
        })
        document.getElementsByClassName('el-container')[0].addEventListener('mouseup',function () {
          event.stopPropagation();
        })
      },
      init(){
        let vm = this;
        vm.userName = sessionStorage.getItem('userName');
        this.clientHeight = parseInt(document.documentElement.clientHeight || window.innerHeight);
        //console.log(parseInt(document.documentElement.clientHeight || window.innerHeight))
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth()+1;
        let day = date.getDate();
        let week = date.getDay();
        switch (week){
          case 1:
            week = "一";
            break;
          case 2:
            week = "二";
            break;
          case 3:
            week = "三";
            break;
          case 4:
            week = "四";
            break;
          case 5:
            week = "五";
            break;
          case 6:
            week = "六";
            break;
          case 0:
            week = "日";
            break;
        }
        this.date =  year+"年"+month+"月"+day+"日"+" 星期"+week;

      },

      // 查询角色所拥有模块
      queryModular(){
        let vm = this;
        this.axios.get("/common/queryAllMenusById").then((response)=> {
          vm.modularArr = response.data.allMenus;
          console.log('vm.modularArr', vm.modularArr);
//          vm.roleName = response.data.roleName;

          this.getActivePath();
        })
      },

      // 展开/收缩菜单
      hideOrShowSide(){
        if(this.openOrClose === '#icon-caidan1'){
          this.openOrClose = '#icon-caidan';

        }else{
          this.openOrClose = '#icon-caidan1';
        }
        this.isCollapse = !this.isCollapse;
      },

      // 获取初始化展开菜单
      getActivePath(){
        let locationHash = location.hash;
        let activePathExist = locationHash && locationHash.split('#')[1];
        if (activePathExist) {
          this.activePath = locationHash.split('#')[1];
        } else {
          let firstParentMenuExist = this.modularArr && this.modularArr[0].path;
          if (firstParentMenuExist) {
            this.activePath = this.modularArr[0].path;
          } else {
            for (let ma of this.modularArr) {
              let firstChildrenMenu = ma.children[0] && ma.children[0].path;
              if (firstChildrenMenu) {
                this.activePath = ma.children[0].path;
                break;
              }
            }
          }
        }
      },

      // 退出系统
      exitSystem() {
        let vm = this;
        vm.$router.push('/login');

        // 删除cookie
        let nowDate = new Date();
        nowDate.setTime(-1000);
        document.cookie="userId=''; expires="+nowDate.toGMTString();
      },

      // 修改密码
      modifyPassword() {
        let vm = this;
        vm.dialogPassword = true;
      },
      //提交新密码
      submitNewPassword(){
        let vm =this;
        vm.dialogPassword = false;
        vm.$refs.form.validate((val)=>{
          if(val){
            let params = {
              oldPwd:vm.passwordForm.oldPassword,
              newPwd:vm.passwordForm.newPassword,
            }
            console.log(params);
            vm.axios.post('/common/updataPwdByLoginId', params)
              .then(res=>{
                console.log(res.data)
                if(res.data.resultCode === '00'){
                  vm.$alert('密码修改成功,请重新登录!', '提示', {
                    confirmButtonText: '确定',
                    type:'success',
                    callback: action => {
                      vm.$router.push({path:'/'})
                    }
                  });
                }else if(res.data.resultCode === '08'){
                  vm.passwordForm.oldPassword = '';
                  vm.$alert('旧密码不正确!', '提示', {
                    confirmButtonText: '确定',
                    type:'error',
                    callback: action => {
                      vm.$refs.form.clearValidate();
                      vm.dialogPassword = true;
                    }
                  });
                }
              }).catch(val=>{
              console.log(val)
            })
          }
        })
      },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    },
    watch:{
      $route(value){
        this.getActivePath();
      }
    }
  };
</script>

<style scoped lang="scss">
  *{
    font-family:  "Microsoft YaHei";
  }
  .icon{
    color:#fff;
    width: 2em; height: 2em;
    /*vertical-align: -2em;*/
    margin:13px 30px 0 10px ;
    fill: currentColor;
    overflow: hidden;
    cursor: pointer;
  }
  .iconExit{
    color:#fff;
    width: 1.3em; height: 1.3em;
    /*vertical-align: -2em;*/
    margin:0 5px 0 10px ;
    fill: currentColor;
    overflow: hidden;
    cursor: pointer;
  }
  .icon2{
    color:#fff;
    width: 1.5em; height: 1.5em;
    /*vertical-align: -2em;*/
    margin:0 5px 0 10px ;
    fill: currentColor;
    overflow: hidden;
    cursor: pointer;
  }
  .iconMenu{
    color:#fff;
    font-size: 17px;
    /*vertical-align: -2em;*/
    margin:16px 7px 0 10px ;
    fill: currentColor;
    overflow: hidden;
    cursor: pointer;
  }
  .iconMenuOne{
    color:#fff;
    width: 1.2em; height: 1.2em;
    /*vertical-align: -2em;*/
    margin:19px 7px 0 10px ;
    fill: currentColor;
    overflow: hidden;
    cursor: pointer;
  }
  .el-right-main{
    padding: 0 10px 10px 10px;
    min-width: 650px;
    background-color: #EEEEEE;
    overflow-y: auto;
  }
  /*.el-main-route{
    height: 100%;
    background-color:#FFFFFF;
    overflow-y: scroll;
  }*/
  .welcome{
    font-size:22px;
  }
  .clearfix:after{display:block;content:"";clear:both;}
  .clearfix{zoom:1;}
  .fl{float:left;}
  .fr{float:right;}
  .el-header{
    background-color: #2d99d7;
    color: #fff;
    line-height: 60px;
    padding:0;
    margin: 0;
  }
  .el-aside {
    background-color: #545c64;
    color: #333;
    /*line-height: 200px;*/
  }

  .el-main {
    background-color: #eee;
    color: #333;
    /*line-height: 160px;*/
    padding:0;
    overflow-y: hidden;
  }
  body > .el-container {
    margin-bottom: 40px;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
    height: 776px;
  }
  .el-menu-vertical-demo-grandparents{
    max-width: 200px;
    min-height: 400px;
    overflow: hidden;
    position: relative;
  }
  .el-menu-vertical-demo-parent{
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: content-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout.vue